import api from "./api";

export const CadastrarCupons = async (data) => {
  try {
    const response = await api.post(`/cupom-promocional`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const EditarCupons = async (data, id) => {
  try {
    const response = await api.put(`/cupom-promocional/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetCupons = async () => {
  try {
    const response = await api.get(`/cupom-promocional`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetDatasAtivacaoCupom = async (idCupom) => {
  try {
    const response = await api.get(`/cupom-promocional/${idCupom}/buscar-datas-ativacao`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetCuponsByEstabelecimento = async (id) => {
  try {
    const response = await api.get(`/cupom-promocional/estabelecimento/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetCuponsById = async (id) => {
  try {
    const response = await api.get(`/cupom-promocional/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetCuponsByData = async (data) => {
  try {
    const response = await api.post(`/cupom-promocional/por-data`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const CriarCupons = async (data) => {
  try {
    const response = await api.post(`/cupom-promocional`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const AlterarCupons = async (data) => {
  try {
    const response = await api.put(`/cupom-promocional`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const DeleteCupons = async (id) => {
  try {
    const response = await api.delete(`/cupom-promocional/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
